import { Component, HostListener, Injector } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Servers } from 'src/app/common/enumerations/servers-enum';

@Component({
  selector: 'head-page',
  templateUrl: './head-page.component.html',
  styleUrls: ['./head-page.component.scss']
})
export class HeadPageComponent extends BaseComponent {
  environmentLabel = 'local';
  private resizeTimer: any;

  constructor(
    protected override injector: Injector
  ) {
    super(injector);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.innerWidth = (event.target as Window).innerWidth;
    }, 200);
  }


  ngOnInit() {
    this.innerWidth = window.innerWidth;

    if (document.location.hostname === Servers.PRODUCTION) {
      this.environmentLabel = 'prod';
    } else {
      if (document.location.host === Servers.DEVELOPMENT) {
        this.environmentLabel = 'dev';
      } else if (document.location.host === Servers.STAGING) {
        this.environmentLabel = 'test';
      } else if (document.location.host === Servers.PREPROD) {
        this.environmentLabel = 'prep';
      }
    }
  }

}
